var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"map-wrapper",class:{ compact: _vm.$route.name == 'get-code' }},[_c('div',{attrs:{"id":"map"}})]),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1508920a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/pages/Pickup/pickup.template.html
// module id = gB7T
// module chunks = 1